var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',{class:{active: _vm.current === 1}},[_vm._v("① 内容の入力")]),_vm._v(" "),_c('li',{class:{active: _vm.current === 2}},[_vm._v("② 内容の確認")]),_vm._v(" "),_c('li',{class:{active: _vm.current === 3}},[_vm._v("③ 送信完了")])])}
var staticRenderFns = []

export { render, staticRenderFns }